import API from "./GlobalAPI";
import jwt from "jsonwebtoken";
import { getUserById } from "./UserAPI";
import axios from "axios";

const jwt_secret: string = "2d4bb6fa-c62c-46c2-9fa4-e4bfc7ab78ec";

export async function decodeToken(token: string) {
  const result: any = jwt.verify(token, jwt_secret);

  try {
    const user = await getUserById(result.id);
    return user;
  } catch (e) {
    return null;
  }
}

export function saveToken(token: string) {
  localStorage.setItem("token", JSON.stringify(token));
}

export async function Login(data: any) {
  try {
    const res: any = await API.postMethod("auth/local", data);
    return res;
  } catch (e) {
    return e;
  }
}
export function setAuthorization(token: string) {
  if (token) {
    axios.defaults.headers["Authorization"] = `Bearer ${token}`;
  } else {
    delete axios.defaults.headers["Authorization"];
  }
}

export async function getDataFromToken(token: string) {
  if (token) {
    setAuthorization(token);

    try {
      const user = await decodeToken(token);
      return user;
    } catch (e) {
      return null;
    }
  }
}

export async function Register(data: any) {
  try {
    const res: any = await API.postMethod("auth/local/register", data);
    return res;
  } catch (e) {
    return e;
  }
}
